import { types, getParent, flow } from 'mobx-state-tree';
import { TerminalRow } from './models';
import { resolvePaginationStore } from '../PaginationStore';

const TerminalsStore = types
  .model('TerminalsStore', {
    terminals: types.array(TerminalRow),
    pagination: types.optional(
      resolvePaginationStore({
        onChangePerPage: (self) => getParent(self).loadTerminals(),
        onChangePage: (self, page) => getParent(self).loadTerminals({ page }),
      }),
      {
        perPage: 50
      },
    ),
  })
  .volatile(self => ({
    loading: false,
  }))
  .views(self => ({
    get root() {
      return getParent(self);
    },
  }))
  .actions(self => ({
    loadTerminals: flow(function* ({ page = 1 } = {}) {
      try {
        self.loading = true;
        const response = yield self.root.api.terminal.index({ page: page, per_page: self.pagination.perPage });
        self.terminals = response.data.data;
        self.pagination.setFromMeta(response.data.meta);
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.loading = false;
    }),
    destroy: flow(function* (id) {
      let response;
      if (window.confirm('Are you sure to delete it?')) {
        try {
          self.loading = true;
          response = yield self.root.api.terminal.destroy(id);
          self.loadTerminals();
        } catch (error) {
          self.root.ui.toast.error(error);
        }
        self.loading = false;
      }
    }),
  }))


export default TerminalsStore;
